







import { Component, Vue } from 'vue-property-decorator';

// components
import FreeCellTable from './components/FreeCellTable.vue';
import Console from './components/Console.vue';
import LightBox from './components/LightBox.vue';

import FreeCellStore from '@/FreeCellStore';

@Component({
  components: {
    FreeCellTable,
    Console,
    LightBox
  }
})
export default class App extends Vue {

  created() {
    this.$store.registerModule('FreeCellStore', FreeCellStore); // 註冊模組
  }


  // mounted() {
  //   this.isLightBoxInit = !!this.$store.state.FreeCellStore.lightBox
  // }

}
